import { WorkareaPricingData } from "./workareas/workareaPricing"
import { ProjectStatus, ProjectType } from "../common/constants"

export type Job = {
  id: number
  name: string
  no: string
  type: ProjectType
  workareas: Workarea[]
}

export type Workarea = {
  id: number
  jobId: number
  name: string
  workareaGroupId: string
  sortIndex: number
  master?: boolean
  masterWorkareaId?: number
  quotedPrice?: number
  recovery?: number
  pricing?: WorkareaPricingData | null
  workSubtotal?: number | null
  isApproved: boolean
  isOnHold: boolean
  scheduleDate?: string
  status?: ProjectStatus
  divisionId?: number | null
  costCodeId?: number | null
  customQuotedPrice?: number | null
  notes?: string
  customLaborRateItemId?: number | null
  showTaxInFinalPrice: boolean
  completedDate?: string | null
  recurringScheduleConfig?: string
  estimatedOccurrences?: number,
  customerAndInvoiceNotes?: string
  invoiceDescription?: string | null
}

export const defaultWorkarea = (): Workarea => ({
  id: 0,
  jobId: 0,
  name: '',
  workareaGroupId: '',
  sortIndex: 0,
  isApproved: false,
  isOnHold: false,
  notes: '',
  showTaxInFinalPrice: false
})
